import { create } from 'zustand';

interface HelpRequestState {
  apiValidationErrors: string[];
  helpCategories: string[];
  districts: string[];
  statuses: string[];
  states: string[];
  counties: string[];

  clearApiValidationErrors: () => void;
  resetToDefaults: () => void;
  setApiValidationErrors: (apiValidationErrors: string[]) => void;
  setHelpCategories: (helpCategories: string[]) => void;
  setDistricts: (districts: string[]) => void;
  setStates: (states: string[]) => void;
  setCounties: (counties: string[]) => void;
  setStatuses: (statuses: string[]) => void;
}

export const useHelpRequestStore = create<HelpRequestState>((set) => ({
  helpCategories: [],
  districts: [],
  statuses: [],
  states: [],
  counties: [],
  apiValidationErrors: [],

  clearApiValidationErrors: () => set({ apiValidationErrors: [] }),
  setApiValidationErrors: (apiValidationErrors: string[]) => set({ apiValidationErrors }),
  setHelpCategories: (helpCategories: string[]) => set({ helpCategories }),
  setDistricts: (districts: string[]) => set({ districts }),
  setStates: (states: string[]) => set({ states }),
  setCounties: (counties: string[]) => set({ counties }),
  setStatuses: (statuses: string[]) => set({ statuses }),
  resetToDefaults: () =>
    set({
      helpCategories: [],
      districts: [],
      statuses: [],
      states: [],
      counties: [],
      apiValidationErrors: [],
    }),
}));
